import { hfbXxxStringTranslator, useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { AREA_OPTIONS } from "../types/media";

const AREA_ID = "area";

export function useAreaFilter(areas: string[]) {
  const { t } = useTranslation();
  const defaultValue = { filterId: AREA_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: AREA_ID,
      title: t("areaString"),
      options: areas.map((area) => {
        const areaOption = AREA_OPTIONS.find((opt) => opt.value === area);
        if (areaOption) {
          return {
            value: area,
            title: t(areaOption.translationKey),
          };
        }
        return {
          value: area,
          title: `${area} - ${hfbXxxStringTranslator(area.split(" ")[1], t)}`,
        };
      }),
      enabled: true,
      defaultValue,
    },
    t("allAreasString")
  );
}
